import { jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "@mui/material";
export const TruffleLink = (props) => {
    return (_jsxs(Link, Object.assign({}, props, { sx: { gap: "4px", display: "flex", alignItems: "center" }, children: [props.startIcon, props.children, props.endIcon] })));
};
//# sourceMappingURL=TruffleLink.js.map